import ENV from './env'

// 确保 ENV.BASE_URL 有值，防止出现 undefined
const BASE_URL = ENV?.BASE_URL ?? ''

const API = {
  HOME: {
    INFO: `${BASE_URL}/comic/v1/api/home/comic`,
    /** 首页 Banner 轮播列表（无需登录） */
    BANNER_LIST: `${BASE_URL}/comic/v1/api/home/banner/list`,
  },
  COMIC: {
    THEME_SON_SELECT: `${BASE_URL}/comic/v1/api/comic/theme/son/select`,
    SEARCH: `${BASE_URL}/comic/v1/api/comic/search`,
    CLASSIFY: `${BASE_URL}/comic/v1/api/comic/classify`,
    DETAIL: `${BASE_URL}/comic/v1/api/comic/detail`,
    GET_VOL_PAGES: `${BASE_URL}/comic/v1/api/comic/vol/all`,
    CATALOG: `${BASE_URL}/comic/v1/api/comic/catalog`,
    VOL_INTERACT: `${BASE_URL}/comic/v1/api/comic/vol/interactPart`,
    /** 购卷预览（需登录，不传金额） */
    VOL_PAY_PREVIEW: `${BASE_URL}/comic/v1/api/comic/vol/pay/preview`,
    /** 购卷下单（需登录，不传金额） */
    VOL_PAY_BUY: `${BASE_URL}/comic/v1/api/comic/vol/pay/buy`,
    /** 购卷场景充值预览（带差额与推荐档） */
    VOL_PAY_RECHARGE_PREVIEW: `${BASE_URL}/comic/v1/api/comic/vol/pay/recharge/preview`,
  },
  AGREEMENT: {
    /** 协议详情（VOL_PAY / GOLD_RECHARGE） */
    DETAIL: `${BASE_URL}/comic/v1/api/agreement/detail`,
  },
  PAY: {
    /** 打赏金额档位列表（无需登录） */
    TIP_AMOUNT_LIST: `${BASE_URL}/comic/v1/api/pay/tip/amount/list`,
    /** 微信打赏预下单 */
    TIP_WECHAT_PREPARE: `${BASE_URL}/comic/v1/api/pay/tip/wechat/prepare`,
    /** 按订单 ID 查打赏状态 */
    TIP_WECHAT_ORDER_STATUS: `${BASE_URL}/comic/v1/api/pay/tip/wechat/order/status`,
    /** 按商户单号查打赏状态 */
    TIP_WECHAT_ORDER_BY_OUT_TRADE_NO: `${BASE_URL}/comic/v1/api/pay/tip/wechat/order/byOutTradeNo`,
    /** 用户中心橘子币档位列表 */
    GOLD_PACKAGE_LIST: `${BASE_URL}/comic/v1/api/pay/gold/package/list`,
    /** 橘子币微信预下单 */
    GOLD_WECHAT_PREPARE: `${BASE_URL}/comic/v1/api/pay/gold/wechat/prepare`,
    /** 橘子币微信查单 */
    GOLD_WECHAT_ORDER_STATUS: `${BASE_URL}/comic/v1/api/pay/gold/wechat/order/status`,
  },
  AUTH: {
    SMS_SEND: `${BASE_URL}/comic/v1/sms/send`,
    SIGN_UP: `${BASE_URL}/comic/v1/sign/up/1/3`,
    SIGN_IN: `${BASE_URL}/comic/v1/sign/in/1/3`,
    SIGN_OUT: `${BASE_URL}/comic/v1/sign/out`,
  },
  USER: {
    BASE: `${BASE_URL}/comic/v1/api/user/base`,
    AVATAR_UPLOAD: `${BASE_URL}/comic/v1/api/user/base/avatar/upload`,
    BASE_MODIFIED: `${BASE_URL}/comic/v1/api/user/base/modified`,
    PASSWORD_MODIFIED: `${BASE_URL}/comic/v1/api/user/password/modified`,
    READ_PROGRESS: `${BASE_URL}/comic/v1/api/user/read`,
    CLOCK_DO: `${BASE_URL}/comic/v1/api/user/clock/do`,
    CLOCK_RECORD: `${BASE_URL}/comic/v1/api/user/clock/record`,
    CLOCK_MAKEUP: `${BASE_URL}/comic/v1/api/user/clock/makeup`,
    GOLD_RECORD_PAGE: `${BASE_URL}/comic/v1/api/user/gold/record/page`
  },
  USER_COLLECT: {
    INSERT: `${BASE_URL}/comic/v1/api/user/collect/insert`,
    CANCEL: `${BASE_URL}/comic/v1/api/user/collect/cancel`,
    PAGE: `${BASE_URL}/comic/v1/api/user/collect/page`
  },
  USER_HISTORY: {
    PAGE: `${BASE_URL}/comic/v1/api/user/history/page`
  },
  /** 客户端-用户反馈 */
  FEEDBACK: {
    SUBMIT: `${BASE_URL}/comic/v1/api/feedback/submit`,
    PAGE: `${BASE_URL}/comic/v1/api/feedback/page`,
    DETAIL: `${BASE_URL}/comic/v1/api/feedback/detail`,
  },
  USER_SEARCH_HISTORY: {
    PAGE: `${BASE_URL}/comic/v1/api/user/search/history/page`,
    DELETE: `${BASE_URL}/comic/v1/api/user/search/history/delete`,
    CLEAR: `${BASE_URL}/comic/v1/api/user/search/history/clear`
  },
  MESSAGE: {
    ADD: `${BASE_URL}/comic/v1/api/message/add`, // 消息新增（留言/评论）
    PAGE: `${BASE_URL}/comic/v1/api/message/page`, // 消息分页（留言/评论）
    REPLY: `${BASE_URL}/comic/v1/api/message/reply`, // 消息回复
    REPLY_PAGE: `${BASE_URL}/comic/v1/api/message/reply/page`, // 消息回复分页
    DELETE: `${BASE_URL}/comic/v1/api/message/delete`, // 删除消息（评论/留言/回复）
    LIKE_INSERT: `${BASE_URL}/comic/v1/api/user/like/insert`,
    LIKE_CANCEL: `${BASE_URL}/comic/v1/api/user/like/cancel`,
    INTERACTION_PAGE: `${BASE_URL}/comic/v1/api/message/interaction/page`,
    INTERACTION_READ: `${BASE_URL}/comic/v1/api/message/interaction/read`,
    INTERACTION_UNREAD_COUNT: `${BASE_URL}/comic/v1/api/message/interaction/unread/count`,
    INTERACTION_UNREAD_STREAM: `${BASE_URL}/comic/v1/api/message/interaction/unread/stream`
  },
  /** 弹幕（阅读页） */
  USER_DANMAKU: {
    CONF: `${BASE_URL}/comic/v1/api/user/danmaku/conf`,
    CONF_UPDATE: `${BASE_URL}/comic/v1/api/user/danmaku/conf/update`,
    LAUNCH_QUERY: `${BASE_URL}/comic/v1/api/user/danmaku/launch/query`,
    LAUNCH_SEND: `${BASE_URL}/comic/v1/api/user/danmaku/launch/send`,
    LAUNCH_LIKE: `${BASE_URL}/comic/v1/api/user/danmaku/launch/like`,
    LAUNCH_UNLIKE: `${BASE_URL}/comic/v1/api/user/danmaku/launch/unlike`,
    LAUNCH_LIKED: `${BASE_URL}/comic/v1/api/user/danmaku/launch/liked`
  }
}

export default API
